module.exports = __webpack_public_path__ + "static/img/boss_fleetgrid.a9fb4125.png";